import { render, staticRenderFns } from "./BaseTokenInput.vue?vue&type=template&id=f39d16b0&scoped=true&"
import script from "./BaseTokenInput.vue?vue&type=script&lang=js&"
export * from "./BaseTokenInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseTokenInput.vue?vue&type=style&index=0&id=f39d16b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39d16b0",
  null
  
)

export default component.exports